// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2tzgl","Logo":"Toolbar_Logo__1fN_j","DesktopOnly":"Toolbar_DesktopOnly__3Ig3D"};